// Fix image URLs for Weglot translations
// This runs after Weglot has translated the page and changed domains
document.addEventListener('DOMContentLoaded', function() {
  function fixImageUrls() {
    // Fix only img elements inside .mega-menu-sidebar--button
    const images = document.querySelectorAll('.mega-menu-sidebar--button img[src*="zusss.com"], .mega-menu-sidebar--button img[src*="zusss.de"], .mega-menu-sidebar--button img[data-src*="zusss.com"], .mega-menu-sidebar--button img[data-src*="zusss.de"], .mega-menu-sidebar--button img[data-srcset*="zusss.com"], .mega-menu-sidebar--button img[data-srcset*="zusss.de"]');
    
    images.forEach(function(img) {
      // Fix src attribute
      if (img.src && (img.src.includes('zusss.com') || img.src.includes('zusss.de'))) {
        img.src = img.src.replace(/\/\/www\.zusss\.com/g, '//www.zusss.nl').replace(/\/\/www\.zusss\.de/g, '//www.zusss.nl');
      }
      
      // Fix data-src attribute (for lazy loading)
      if (img.dataset.src && (img.dataset.src.includes('zusss.com') || img.dataset.src.includes('zusss.de'))) {
        img.dataset.src = img.dataset.src.replace(/\/\/www\.zusss\.com/g, '//www.zusss.nl').replace(/\/\/www\.zusss\.de/g, '//www.zusss.nl');
      }
      
      // Fix data-srcset attribute (for responsive images)
      if (img.dataset.srcset && (img.dataset.srcset.includes('zusss.com') || img.dataset.srcset.includes('zusss.de'))) {
        img.dataset.srcset = img.dataset.srcset.replace(/\/\/www\.zusss\.com/g, '//www.zusss.nl').replace(/\/\/www\.zusss\.de/g, '//www.zusss.nl');
      }
      
      // Fix srcset attribute
      if (img.srcset && (img.srcset.includes('zusss.com') || img.srcset.includes('zusss.de'))) {
        img.srcset = img.srcset.replace(/\/\/www\.zusss\.com/g, '//www.zusss.nl').replace(/\/\/www\.zusss\.de/g, '//www.zusss.nl');
      }
    });
  }
  
  // Run immediately
  fixImageUrls();
  
  // Also run when Weglot changes language (if applicable)
  if (window.Weglot) {
    window.Weglot.on('languageChanged', function() {
      // Small delay to ensure Weglot has finished updating the DOM
      setTimeout(fixImageUrls, 100);
    });
  }
  
  // Run periodically as a fallback (every 2 seconds for first 10 seconds)
  let attempts = 0;
  const maxAttempts = 5;
  const fixInterval = setInterval(function() {
    fixImageUrls();
    attempts++;
    if (attempts >= maxAttempts) {
      clearInterval(fixInterval);
    }
  }, 2000);
});
